import "./Footer.css"

export function Com_Footer() {
    return (
        <div className="footer">
            <p title="1.0.0">久忆互娱（厦门）信息科技有限公司</p>
            <p className="en">Jiuyi Interactive Entertainment (Xiamen) Information Technology Co., Ltd.</p>
            <a className="footer-link" href="/privacy">Privacy Policy</a>
            <p className="footer-reg">闽ICP备2024073642号-1</p>
        </div>
    );
}
